export const MSP_ROLE_HIERARCHY = [
  { mspRoleId: 1, mspRoleName: "Super Admin" },
  { mspRoleId: 2, mspRoleName: "Admin" },
  { mspRoleId: 3, mspRoleName: "Viewer" },
];

export const ORG_ROLE_HIERARCHY = [
  { orgRoleId: 5, orgRoleName: "Super Admin" },
  { orgRoleId: 6, orgRoleName: "Admin" },
  { orgRoleId: 7, orgRoleName: "Viewer" },
];
